import { createApi } from '@stilingue/st-auth-utils';
import { error401Handler } from '@/utils/error';
import Service from './Service';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class SeStudioEndpointService extends Service {
  constructor(gateway) {
    const api = createApi('/se-studio-service/', gateway, {
      authNotFound: () => true,
      error401Handler,
    });

    super(api, {
      afterParser,
      retriesLimit: 10,
    });

    this.api.http.defaults.timeout = 600000;
  }

  backlogTable(params = {}) {
    return this.find({
      ...params,
      url: 'feed/backlog-table',
    });
  }

  importHistory(params = {}) {
    return this.find({
      ...params,
      url: 'feed/import-history',
    });
  }

  statusTable(params) {
    return this.find({
      ...params,
      url: 'status-table',
    });
  }

  countPosts(params) {
    return this.find({
      ...params,
      url: 'post/count',
    });
  }

  sacSurveys(params = {}) {
    return this.find({
      ...params,
      url: 'sac-surveys',
    });
  }

  sacSurveysScores(params) {
    return this.find({
      ...params,
      url: 'sac-surveys/scores',
    });
  }

  gptSuggestion(params) {
    return this.find({
      ...params,
      url: 'gpt/suggestions',
    });
  }

  reply(params) {
    const requestParams = {
      ...params.params,
      url: getUrl('gpt/reply', {
        ...params.params,
      }),
    };

    return this.api.post(requestParams);
  }

  remove(params) {
    const requestParams = {
      ...params.params,
      url: getUrl('gpt/delete', {
        ...params.params,
      }),
    };

    return this.api.post(requestParams);
  }
}

export const paramsToQueryString = (params) => {
  return Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
};

export const getUrl = (path, params) => {
  return `${path}?${paramsToQueryString({ ...params })}`;
};

export default new SeStudioEndpointService(gateway);
